export default __webpack_public_path__ + "static/media/master-card-icon.5e41e658.svg";